/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_NOTIFICATION_ALERTS_SUCCESS,
  FETCH_NOTIFICATION_ALERTS_REQUEST,
  FETCH_NOTIFICATION_ALERTS_FAILURE,
} from '../../constants/ActionTypes';

const list = (
  state = {
    data: [],
    paging: {},
    isFetching: false,
    error: {},
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_ALERTS_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case FETCH_NOTIFICATION_ALERTS_SUCCESS:
      const data = action.data?.data?.data[0] || [];
      const paging = action.data?.data?.data[1] || [];
      const unreadCount = action.data?.data?.data[2]?.unreadCount || 0;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: data,
        paging: paging,
        updatedAt: Date.now(),
        unreadCount,
      };
    case FETCH_NOTIFICATION_ALERTS_FAILURE:
      return { ...state, isFetching: false, error: action.data };
    default:
      return state;
  }
};

const notificationAlerts = combineReducers({
  list,
});

export default notificationAlerts;
